/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const deleteApiProjectsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const deleteApiProjectsId200Schema = z.any();

export const deleteApiProjectsIdMutationResponseSchema = z.lazy(
  () => deleteApiProjectsId200Schema,
);
